import axios from 'axios';
import various from './General/various';
import ogpItem from './ogpItem.json';

const DEFAULT_IMAGE = 'https://www.touzen.jp/touzen/seo-share-default.jpg';
let requestSequence = 0;
const normalizedPath = (path) => {
  const url = new URL(path || '/', window.location.origin);
  if (url.origin !== window.location.origin) return null;
  return url.pathname.replace(/\/{2,}/g, '/').replace(/\/$/, '') || '/';
};
const isYowan = () => {
  const host = window.location.hostname.toLowerCase();
  return window.__NODE_V11_DOMAIN_APP__ === 'yowan' || host === 'yowan.jp' ||
    host.endsWith('.yowan.jp') || ['yowan-stg.shimashou.com', 'yowan-prod.shimashou.com'].includes(host) ||
    (process.env.REACT_APP_ENVIRONMENT === 'development' && new URLSearchParams(window.location.search).get('domain') === 'yowan');
};
const setMeta = (attribute, key, content) => {
  const matches = [...document.head.querySelectorAll(`meta[${attribute}="${key}"]`)];
  const element = matches.shift() || document.createElement('meta');
  matches.forEach((duplicate) => duplicate.remove());
  element.setAttribute(attribute, key);
  element.setAttribute('content', String(content));
  if (!element.parentNode) document.head.appendChild(element);
};
const applyImage = (share = { url: DEFAULT_IMAGE, width: 1200, height: 630, type: 'image/jpeg' }) => {
  setMeta('property', 'og:image', share.url);
  setMeta('property', 'og:image:width', share.width);
  setMeta('property', 'og:image:height', share.height);
  setMeta('property', 'og:image:type', share.type);
  setMeta('name', 'twitter:image', share.url);
};

export const ogpGenerator = async (props = {}) => {
  const sequence = ++requestSequence;
  if (isYowan()) return;
  const path = normalizedPath(props.path);
  const item = ogpItem[props.page] || { type: 'website', description: '' };
  // Keep existing caller-owned social title/url/type/description behavior.
  // This image pipeline does not manage robots, canonical or JSON-LD authority.
  const url = `${window.location.origin}${props.path || '/'}`;
  setMeta('property', 'og:url', url);
  setMeta('property', 'og:type', item.type);
  setMeta('property', 'og:title', props.pageTitle || '刀禅');
  setMeta('property', 'og:description', item.description);
  setMeta('name', 'twitter:url', url);
  setMeta('name', 'twitter:title', props.pageTitle || '刀禅');
  setMeta('name', 'twitter:description', item.description);
  // Original imageUrl is deliberately ignored; missing/error always resets to
  // the prepared bundled JPEG, including exact dimensions and content type.
  applyImage();
  const operational = ['seminar_apply', 'login', 'forgot', 'forgot_confirm', 'unsubscribe', 'unsubscribe_confirm', 'nomatch'].includes(props.page);
  if (operational || !path) return;
  const current = () => sequence === requestSequence && !isYowan() && normalizedPath(window.location.pathname) === path;
  try {
    const response = await axios.get(`${various.currentDomain}api/seo/resolve/`, { params: { path } });
    if (!current()) return;
    const route = response.data;
    const share = route.image_profiles?.share;
    if (route.indexable === true && route.canonical_path === path && share?.url && share.width && share.height && share.type) {
      applyImage(share);
    }
  } catch {
    // The default was set synchronously. Failed/late lookups cannot restore an
    // original or prior-route image and cannot change server indexing policy.
  }
};
